/**
 *
 * Asynchronously loads the component for KentaaConfig
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
